/* eslint-disable */
import YakFetch from './utils/yak_fetch';
import ServiceBase from './service_base';

export default class TackAiChatService extends ServiceBase {
  // Sends the user's guess to Yak Tack chat endpoint and returns Yak's reply.
  // tackSlug  - slug of the tack (acts as :tack_id route param)
  // userMessage - string user input
  static async chat(tackSlug, userMessage) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/tack_ai_agent/${encodeURIComponent(tackSlug)}/chat`;
    const response = await YakFetch.fetch(endpoint, 'POST', {
      body: { user_message: userMessage }
    });
    await TackAiChatService._abortIfUnsuccessful(response);
    const json = await response.json();
    return json; // { ai_response_message, user_message_definition_accuracy }
  }
} 


// WEBPACK FOOTER //
// ./src/services/tack_ai_chat_service.js